export enum Product { 
    Core =  'core',
    Outlook = 'outlook',
}